import React from 'react';
import { observer } from 'src/utils/mobx-react';

import { AccountNavigationWrapper } from './AccountNavigation.style';
import { SignUpLinkNav } from 'src/domains/players/webview/components/Account/accountPanel/accountNavigation/signUpLinkNav/SignUpLinkNav';
import { LogInLinkNav } from 'src/domains/players/webview/components/Account/accountPanel/accountNavigation/loginLinkNav/LoginLinkNav';
import { FaqLinkNav } from 'src/domains/players/webview/components/Account/accountPanel/accountNavigation/faqLinkNav/FaqLinkNav';
import { BalanceLinkNav } from 'src/domains/players/webview/components/Account/accountPanel/accountNavigation/balanceLinkNav/BalanceLinkNav';
import { AccountLinkNav } from 'src/domains/players/webview/components/Account/accountPanel/accountNavigation/accountLinkNav/AccountLinkNav';
import { TraderChatLinkNav } from 'src/domains/players/webview/components/Account/accountPanel/accountNavigation/traderChatLinkNav/TraderChatLinkNav';
import { RouteViewType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { useCommon } from 'src/domains/common/Common';
import { TraderChatState } from 'src/domains/players/state/traderChat/TraderChatState';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { UniverseComponent } from 'src/domains/common/universes';
import { AccountNavVariantType } from 'src/domains/layouts/config/features/types';

interface AccountNavigationPropsType {
    currentView: RouteViewType | null;
}

export const AccountNavigation = observer('AccountNavigation', ({ currentView }: AccountNavigationPropsType) => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const traderChatState = TraderChatState.get(common);
    const { isAuthorized } = common.session;

    const {
        faqSection,
        componentVariants: { accountNavVariant },
    } = configState;
    const routeName = currentView?.name;

    if (isAuthorized === true) {
        return (
            <AccountNavigationWrapper variant={accountNavVariant}>
                {accountNavVariant === AccountNavVariantType.SECONDARY ? (
                    <UniverseComponent>
                        {(universeModule): React.ReactElement => <universeModule.accountNavButton />}
                    </UniverseComponent>
                ) : (
                    <BalanceLinkNav />
                )}
                {traderChatState.isTraderChatForView && routeName !== 'casino' ? <TraderChatLinkNav /> : null}
                {faqSection.isOnForAuthorized ? <FaqLinkNav /> : null}
                <AccountLinkNav />
            </AccountNavigationWrapper>
        );
    }

    return (
        <AccountNavigationWrapper variant={accountNavVariant}>
            <LogInLinkNav />
            <SignUpLinkNav />
            {faqSection.isOnForNonAuthorized ? <FaqLinkNav /> : null}
        </AccountNavigationWrapper>
    );
});
